import { ActionType } from "./actions.js";
import { isListed } from "./membership.js";
import { addDictionaryAction, dictionaryEntries, dictionaryIds, hasDictionaryKind, removeDictionaryAction, selectDictionaryRow, updateDictionaryAction } from "./atom.actions.js";
//#region src/engine/modules/dictionary/history.ts
function pushPreviousValues(undoActions, { kind, id, values }, state) {
	const entity = selectDictionaryRow(state, kind, id);
	const fields = dictionaryEntries(kind, values);
	if (!entity || !fields.length) return;
	undoActions.push(updateDictionaryAction({
		kind,
		id,
		values: Object.fromEntries(fields.map(([field]) => [field, Reflect.get(entity, field)]))
	}));
}
var addDictionary = (undoActions, { payload }, state) => {
	const { kind, id } = payload;
	if (!hasDictionaryKind(kind)) return;
	if (isListed(dictionaryIds(state, kind), id)) {
		pushPreviousValues(undoActions, payload, state);
		return;
	}
	undoActions.push(removeDictionaryAction({
		kind,
		id
	}));
};
var removeDictionary = (undoActions, { payload: { kind, id } }, state) => {
	if (!hasDictionaryKind(kind)) return;
	if (!isListed(dictionaryIds(state, kind), id)) return;
	undoActions.push(addDictionaryAction({
		kind,
		id
	}));
};
var updateDictionary = (undoActions, { payload }, state) => {
	if (!hasDictionaryKind(payload.kind)) return;
	pushPreviousValues(undoActions, payload, state);
};
var isListing = ({ type }) => type === ActionType.addDictionary || type === ActionType.removeDictionary;
function reverseDictionaryListings(undoActions) {
	const slots = undoActions.flatMap((action, index) => isListing(action) ? [index] : []);
	for (let low = 0, high = slots.length - 1; low < high; low++, high--) {
		const action = undoActions[slots[low]];
		undoActions[slots[low]] = undoActions[slots[high]];
		undoActions[slots[high]] = action;
	}
}
var dictionaryPushUndoHistoryMap = {
	[ActionType.addDictionary]: addDictionary,
	[ActionType.updateDictionary]: updateDictionary,
	[ActionType.removeDictionary]: removeDictionary
};
//#endregion
export { dictionaryPushUndoHistoryMap, reverseDictionaryListings };
